<div class="container-fluid">
  <div class="col-12">
    <h3 i18n="@@my_referrals">Reporte de "Mis referidos"</h3>
  </div>
</div>

<div class="container-fluid">
  <div class="col-12" style="display: flex; flex-direction: row;">
    <p i18n="@@movements_period">Fecha: </p>
    <div style="width: 180px; margin-left: 10px">
      <select class="custom-select" required [(ngModel)]="selectedValue">
        <option *ngFor="let month of months" [ngValue]="month">{{month.name}}</option>
      </select>
    </div>
    <button class="btn btn-outline-primary" type="button" style="margin-left: 10px; height: 38px" (click)="onReferralReportSelection(selectedValue)" i18n="@@b6bc65f3e9576dc6ac1493740124944c259a11f4">Buscar</button>
  </div>
</div>

<div class="container-fluid">
  <div class="col-12" *ngIf="referralsReport?.reportItems.length > 0">
      <p-table [value]="referralsReport.reportItems">
        <ng-template pTemplate="header">
          <tr>
            <th class="text-center" i18n="@@my_referrals_level">Nivel</th>
            <th class="text-center" i18n="@@my_referrals_own_referrals">Referidos</th>
            <th class="text-center" i18n="@@my_referrals_active">Referidos activos</th>
            <th class="text-center" i18n="@@my_referrals_earned">Comisión ganada</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td class="text-center">{{ item.levelOfHierarchy }}</td>
            <td class="text-center">{{ item.referredTotalCount }}</td>
            <td class="text-center">{{ item.referredActiveCount }}</td>
            <td class="text-center">{{ item.total | currency:'US $':'symbol':'1.2':'en' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td></td>
            <td></td>
            <td style="display: flex; flex-direction: row-reverse" i18n="@@my_referrals_total">Ganancia Total</td>
            <td class="text-center">{{referralsReport.total | currency:'US $':'symbol':'1.2':'en'}}</td>
          </tr>
        </ng-template>
      </p-table>
  </div>
  <div class="col-12" *ngIf="referralsReport?.reportItems.length === 0">
    <p i18n="@@balanceNoMovements">No hay movimientos registrados</p>
  </div>
</div>
